import React from 'react';

import {RegressionTypeChartParameters} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import {StringValueDropdownSelector} from 'insights/analytics-visualizations/configs/form-components/DropdownSelector';
import {VisualizationConfigEditorComponentProps} from 'insights/analytics-visualizations/configs/VisualizationConfigEditorTypes';
import {getRegressionTypeFromConfig} from 'insights/analytics-visualizations/data/getRegressionType';
import {
  REGRESSION_TYPE_TO_DEFAULT_CONFIG,
  REGRESSION_TYPE_TO_READABLE,
} from 'ui-library/charting/statistics/regression/Constants';
import {isRegressionConfigModalSupportedConfig} from 'ui-library/charting/statistics/regression/regression-config-modal/RegressionConfigModal';
import {RegressionConfig, RegressionType} from 'ui-library/charting/statistics/regression/RegressionTypes';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import RegressionSettingsIcon from './RegressionSettingsIcon';

const ORDERED_REGRESSION_TYPES: Array<RegressionType> = [RegressionType.LINEAR, RegressionType.LOGISTIC];

/** @package */
export const EXCLUDED_REGRESSION_TYPES: Array<RegressionType> = [RegressionType.QUADRATIC];

export type RegressionConfigEditorProps =
  VisualizationConfigEditorComponentProps<RegressionTypeChartParameters> & {
    errorMessage?: string | null;
  };

export default function RegressionConfigEditor({
  parameters,
  onUpdateParameters,
  errorMessage,
  isDisabled = false,
}: RegressionConfigEditorProps): JSX.Element {
  function handleUpdateRegression(newRegressionType: RegressionType | null): void {
    if (getRegressionTypeFromConfig(parameters.regressionConfig) !== newRegressionType) {
      onUpdateParameters({
        ...parameters,
        regressionConfig: newRegressionType ? REGRESSION_TYPE_TO_DEFAULT_CONFIG[newRegressionType] : null,
      });
    }
  }

  function handleRequestSubmit(newRegressionConfig: RegressionConfig): void {
    onUpdateParameters({
      ...parameters,
      regressionConfig: newRegressionConfig,
    });
  }

  return (
    <div className="u-input-spacing-top">
      <FieldLabel label="Regression line" />
      <div className="u-vertical-center-items">
        <div className="u-flex-grow">
          <StringValueDropdownSelector
            allowNull={true}
            errorMessage={errorMessage}
            onChange={handleUpdateRegression}
            searchable={false}
            selectedValue={getRegressionTypeFromConfig(parameters.regressionConfig)}
            values={ORDERED_REGRESSION_TYPES}
            valueToReadable={(regressionType) => REGRESSION_TYPE_TO_READABLE[regressionType]}
            isDisabled={isDisabled}
          />
        </div>
        {isRegressionConfigModalSupportedConfig(parameters.regressionConfig) && (
          <RegressionSettingsIcon
            regressionConfig={parameters.regressionConfig}
            onRequestSubmit={handleRequestSubmit}
            isDisabled={isDisabled}
          />
        )}
      </div>
    </div>
  );
}
